import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ErrorMessage = props => {
    const { isVisible = false, messageText = false, textReplacements, errorWrapperClasses, errorClasses, dataTestId } = props;
    // Unique per mount when callers omit dataTestId (avoids duplicate data-testid on the page).
    const autoTestId = React.useId().replace(/:/g, '');
    const resolvedTestId = dataTestId ?? `validation-error-message-${autoTestId}`;

    return isVisible ? (
        <div className={`${errorWrapperClasses ? errorWrapperClasses.join(' ') : ''}`}>
            <span
                className={`${isVisible ? 'shown' : 'hidden'} error--msg ${errorClasses ? errorClasses.join(' ') : ''}`}
                data-testid={resolvedTestId}
            >
                <em>
                    <FontAwesomeIcon icon="exclamation" />
                </em>
                <FormattedMessage
                    id={messageText === false ? 'common.no_text' : messageText}
                    values={{ 
                        text: textReplacements,
                        br: <br/>,
                        strong: chunks => <strong>{chunks}</strong>,
                        ...(textReplacements && typeof textReplacements === 'object' ? textReplacements : {}),
                    }}
                />
            </span>
        </div>
    ) : null;
};

export default ErrorMessage;
